import { gql } from '@apollo/client'

export const GET_PUBLISH_QUEUE = gql`
  query GetPublishQueue($clientId: ID!) {
    publishQueue(clientId: $clientId) {
      id clientId runId contentType content subject
      compliance { approved issues suggestedFixes }
      status approvedAt publishedAt errorMessage rejectedFeedback createdAt
      publishResults { platform success platformPostId platformUrl error }
      publishedTo seoMetadata { metaTitle metaDescription slug }
      scheduledFor trackingUrl clickCount targetPlatform imageUrl
      recipientNpi recipientName recipientPractice recipientChannel
      toEmail outreachType talkingPoints
    }
  }
`

export const ADD_TO_PUBLISH_QUEUE = gql`
  mutation AddToPublishQueue($clientId: ID!, $runId: ID, $contentType: String!, $content: String!, $seoMetadata: SeoMetadataInput) {
    addToPublishQueue(clientId: $clientId, runId: $runId, contentType: $contentType, content: $content, seoMetadata: $seoMetadata) {
      id contentType content status createdAt
    }
  }
`

export const PUBLISH_ITEM_NOW = gql`
  mutation PublishItemNow($clientId: ID!, $itemId: ID!) {
    publishItemNow(clientId: $clientId, itemId: $itemId) {
      id status publishedAt updatedAt
    }
  }
`

export const APPROVE_PUBLISH_ITEM = gql`
  mutation ApprovePublishItem($clientId: ID!, $itemId: ID!, $toEmail: String) {
    approvePublishItem(clientId: $clientId, itemId: $itemId, toEmail: $toEmail) {
      id
      status
      updatedAt
      errorMessage
      publishResults { platform success platformUrl error }
    }
  }
`

export const REJECT_PUBLISH_ITEM = gql`
  mutation RejectPublishItem($clientId: ID!, $itemId: ID!, $feedback: String) {
    rejectPublishItem(clientId: $clientId, itemId: $itemId, feedback: $feedback) {
      id status updatedAt
    }
  }
`

export const EDIT_PUBLISH_ITEM = gql`
  mutation EditPublishItem($clientId: ID!, $itemId: ID!, $content: String, $toEmail: String) {
    editPublishItem(clientId: $clientId, itemId: $itemId, content: $content, toEmail: $toEmail) {
      id content toEmail status updatedAt
    }
  }
`

export const SCHEDULE_PUBLISH_ITEM = gql`
  mutation SchedulePublishItem($clientId: ID!, $itemId: ID!, $scheduledFor: String!) {
    schedulePublishItem(clientId: $clientId, itemId: $itemId, scheduledFor: $scheduledFor) {
      id status scheduledFor updatedAt
    }
  }
`

export const DELETE_PUBLISH_ITEM = gql`
  mutation DeletePublishItem($clientId: ID!, $itemId: ID!) {
    deletePublishItem(clientId: $clientId, itemId: $itemId)
  }
`

export const CLEAR_PUBLISH_QUEUE = gql`
  mutation ClearPublishQueue($clientId: ID!, $statuses: [String]) {
    clearPublishQueue(clientId: $clientId, statuses: $statuses)
  }
`
